/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryinfotool3Inputs */

const en_medialibraryinfotool3 = /** @type {(inputs: Medialibraryinfotool3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created with`)
};

const de_medialibraryinfotool3 = /** @type {(inputs: Medialibraryinfotool3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt mit`)
};

/**
* | output |
* | --- |
* | "Created with" |
*
* @param {Medialibraryinfotool3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryinfotool3 = /** @type {((inputs?: Medialibraryinfotool3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryinfotool3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryinfotool3(inputs)
	return de_medialibraryinfotool3(inputs)
});
export { medialibraryinfotool3 as "mediaLibraryInfoTool" }